var submitInProgress = false;

document.addEventListener('DOMContentLoaded', function () {
    var navCta = document.getElementById('nav-cta');
    if (navCta) {
        var navbar = document.querySelector('.navbar');
        var navbarNav = document.getElementById('navbarNav');
        navbarNav.style.marginRight = (navCta.offsetWidth - parseInt(window.getComputedStyle(navbar).paddingRight)) + 'px';
    }

    document.querySelectorAll('.price-class-list .list-group-item-action').forEach(function (item) {
        item.addEventListener('click', function (e) {
            var class_id = this.getAttribute('data-class-id');
            document.querySelectorAll('.list-group-item-action').forEach(function (el) {
                el.classList.remove('active');
            });
            this.classList.add('active');
            document.querySelectorAll('.price-product-list').forEach(function (el) {
                el.style.display = 'none';
            });
            document.querySelectorAll('.price-product-list[data-class-id="' + class_id + '"]').forEach(el => el.style.display = 'block');
        });
    });

    initContactForm();
});

window.loadChats = function () {
    console.log('loadChats');
    if (typeof window.__lc === 'object') {
        loadLivechatinc();
    }
}

window.initContactForm = function () {
    const contactForm = document.getElementById('contact_form')
    if (!contactForm) {
        return;
    }
    
    contactForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submitInProgress) {
            return;
        }
        var submitButton = document.querySelector('#contact_form input[type=submit]');
        submitButton.value = 'Laster...';
        submitButton.setAttribute('disabled', 'disabled');
        document.querySelectorAll('#contact_form ._showOnError, #contact_form ._showOnSuccess').forEach(function (el) {
            el.style.display = 'none';
        });
        submitInProgress = true;
        var data = new FormData(this);
        fetch('/contact', {
            method: 'POST',
            body: data
        }).then(response => response.json()).then(function (res) {
            submitButton.value = 'Send';
            submitButton.removeAttribute('disabled');
            submitInProgress = false;
            if (res.status != 'ok') {
                if (res.message) {
                    document.querySelector('#contact_form ._showOnError p').textContent = res.message;
                    document.querySelector('#contact_form ._showOnError').style.display = 'block';
                }
                return;
            }
            document.querySelector('#contact_form ._showOnSuccess').style.display = 'block';
            document.querySelectorAll('#contact_form input[type=text], #contact_form textarea').forEach(function (el) {
                el.value = '';
            });
        });
    });
}

window.loadLivechatinc = function () {
    window.setTimeout(function () {
        var lc = document.createElement('script');
        lc.type = 'text/javascript';
        lc.async = true;
        lc.defer = true;
        lc.src = 'https://cdn.livechatinc.com/tracking.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(lc, s);
    }, 1000);
}

window.showAllNews = function (e) {
    e.target.classList.add('hide');
    document.querySelectorAll('#news-list .card.hide').forEach(function (el) {
        el.classList.remove('hide');
    });
}
